import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PreinvoiceModel } from './preinvoice.model';
import { PreinvoiceService } from './preinvoice.service';
import * as FileSaver from 'file-saver';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { PreinvoiceDialogDeleteComponent } from './preinvoice-dialog-delete.component';
import { ActivityModel } from '../../user/activity/activity.model';
import { CoreComponent } from '../../../core/header/core.component';
import { InvoicePreinvoiceConst } from '../const';
import { ConvertToInvoiceService } from '../../../modules_v2/income/shared/services/convert-to-invoice.service';
import { DummyComponent } from '../../../shared/dummy.component';
import { consts } from '../../../consts';
import { InvoiceService } from '../invoice/invoice.service';
import { Utils } from '../../../shared/utils';
import { TableService } from '../../../shared/components/table/table.service';
import { PreinvoiceDialogWorkOrderComponent } from './preinvoice-dialog-work-order.component';

@Component({
    selector: 'convfact-preinvoice-list',
    templateUrl: './preinvoice-list.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})
export class PreinvoiceListComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;


  constructor(
    private router: Router,
    private preinvoiceService: PreinvoiceService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private invoiceService: InvoiceService,
    private core: CoreComponent,
    private dummy: DummyComponent,
    private tableService: TableService,
    private convertToInvoiceService: ConvertToInvoiceService
  ) { }

  dataSource: PreinvoiceModel[] = [];
  preSource: PreinvoiceModel[] = [];

  activityData: ActivityModel[] = [];
  preinvoice: PreinvoiceModel;
  showQR = false;
  empty = false;
  ready = false;
  spinner = false;
  month = 0;
  year = 0;
  currentActivityUid: string = this.core.activitySelected;
  searchText: string;
  headerTable: any[] = InvoicePreinvoiceConst.headerTable;

  //Interacciones con la tabla------------------------------------------------------
  onPreInvoiceNumberClick(preInvoiceNumber) {
    this.pdf(preInvoiceNumber.uid); // Llamar a la función pdf con el uid de la preinvoice
  }

  onPreInvoiceIssuerClick(preInvoiceNumber) {
    this.edit(preInvoiceNumber.uid); // Llamar a la función editar con el uid de la preinvoice
  }
  //--------------------------------------------------------------------------------

  public delete(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(PreinvoiceDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      }
      );
  }

  public createPreinvoice() {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.router.navigate([this.router.url + '/create']);
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    const self = this;
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public showQRCode() {
    if (this.showQR === false) {
      this.showQR = true;
    } else {
      this.showQR = false;
    }
  }

  public publish(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    const row = this.dataSource.find(f => f.uid == uid);
    this.convertToInvoiceService.open({
      uid,
      kind: 'presupuesto',
      number: row ? row.preInvoiceNumber : null,
      receiverName: row ? row.receiverName : null,
      total: row ? row.total : null,
    });
  }


  public pdfMail(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.preinvoiceService.pdfMail(uid).then(response => {
      this.displayInfo(response);
      this.dummy.redirectTo(this.router.url);
    }).catch(error => {
      this.displayInfo(error.error['message']);
    })
  }

  public pdf(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.preinvoice = this.dataSource.filter(w => w.uid == uid)[0];

    const fileName = this.preinvoice.preInvoiceNumber + "_" + this.preinvoice.receiverName + ".pdf";

    this.invoiceService.pdf(uid, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, fileName);
    });
  }

  public edit(uid: string): void {
    // Un presupuesto ya convertido a factura no puede editarse. El menú de la
    // tabla ya lo oculta, pero el clic en el emisor (preInvoiceIssuerClick)
    // entra por aquí sin pasar por ese *ngIf, así que lo comprobamos también.
    const row = this.dataSource.find(r => r.uid === uid);
    if (row && (row as any).convertedToInvoice) {
      this.snackBar.open('No se puede editar un presupuesto ya convertido a factura', null, {
        duration: 3000,
      });
      return;
    }

    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.router.navigate(['/invoice/preinvoice/edit/', uid]);
  }

  public ngOnInit() {
    this.getList();
  }

  public getList() {
    this.preinvoiceService.getList(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      }
    );
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public bookPreinvoices(selectedInvoices): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.ready = false;
    this.invoiceService.bookPreinvoices(selectedInvoices, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Excel_Presupuestos"));
      this.ready = true;
    })
  }

  public duplicate(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.ready = false;

    this.preinvoiceService.duplicatePreinvoice(uid).then(
      (response: boolean) => {
        if (response) {
          this.dummy.redirectTo(this.router.url);
          this.ready = true;
        }
        else {
          this.ready = true;
        }
      }
    )
      .catch(err => {
        this.ready = true;
      });
  }


  addInvoiceWorkOrder(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(PreinvoiceDialogWorkOrderComponent, {
      width: '640px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      autoFocus: false,
      data: { uid: null, invoiceUid: uid }
    });
  }

  public convertToDeliveryNote(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.ready = false;

    this.preinvoiceService.preinvoiceConvertToDeliveryNote(uid).then(
      (response: boolean) => {
        if (response) {
          this.dummy.redirectTo("/invoice/deliverynote");
          this.ready = true;
        }
        else {
          this.ready = true;
        }
      }
    )
      .catch(err => {
        this.ready = true;
      });
  }

  public trackByIndex(i: number) { return i; }

}
